// Click Details Popup Component
// Shows detailed click statistics for admin users
// Displays: who clicked, how many times, when

import React from 'react';
import './ClickDetailsPopup.css';

export default function ClickDetailsPopup({ 
  isOpen, 
  onClose, 
  buttonType, 
  competitionName, 
  stats 
}) {
  if (!isOpen || !stats) return null;

  const { totalClicks, userClicks, recentClicks } = stats;
  
  // Convert userClicks object to sorted array (by count descending)
  const userClicksArray = Object.entries(userClicks || {})
    .map(([userId, data]) => ({
      userId,
      ...data
    }))
    .sort((a, b) => b.count - a.count);

  // Format timestamp for display
  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date.toLocaleString('el-GR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="click-popup-overlay" onClick={onClose}>
      <div className="click-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="click-popup-close" onClick={onClose}>×</button>
        
        <div className="click-popup-header">
          <h3>📊 Click Statistics</h3>
          <div className="click-popup-subtitle">
            <span className="click-popup-button-type">{buttonType}</span>
            <span className="click-popup-competition">{competitionName}</span>
          </div>
        </div>

        <div className="click-popup-total">
          <span className="total-label">Total Clicks:</span>
          <span className="total-value">{totalClicks || 0}</span>
        </div>

        <div className="click-popup-section">
          <h4>👥 Clicks by User</h4>
          {userClicksArray.length > 0 ? (
            <div className="user-clicks-list">
              {userClicksArray.map((user, index) => (
                <div key={user.userId} className="user-click-item">
                  <div className="user-click-rank">#{index + 1}</div>
                  <div className="user-click-info">
                    <div className="user-click-name">
                      {user.userName || 'Unknown'}
                      {user.userId === 'anonymous' && (
                        <span className="anonymous-badge">Anonymous</span>
                      )}
                    </div>
                    <div className="user-click-email">{user.userEmail || '-'}</div>
                    <div className="user-click-dates">
                      {user.firstClick && <span>First: {formatDate(user.firstClick)}</span>}
                      <span>Last: {formatDate(user.lastClick)}</span>
                    </div>
                  </div>
                  <div className="user-click-count">
                    <span className="count-number">{user.count}</span>
                    <span className="count-label">clicks</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">No click data available</p>
          )}
        </div>

        <div className="click-popup-section">
          <h4>🕐 Recent Clicks (Last 10)</h4>
          {recentClicks && recentClicks.length > 0 ? (
            <div className="recent-clicks-list">
              {recentClicks.slice(-10).reverse().map((click, index) => (
                <div key={index} className="recent-click-item">
                  <span className="recent-click-user">{click.userName || 'Anonymous'}</span>
                  <span className="recent-click-time">{formatDate(click.timestamp)}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">No recent clicks</p>
          )}
        </div>
      </div>
    </div>
  );
}
